import SadFaceIcon from "components/icons/SadFaceIcon";
import type { IYouTubeVideoFieldsFragment } from "lib/fragments/__generated__/YouTubeVideoFields.generated";
import { FormattedMessage } from "react-intl";

interface VideosContentProps {
  youtubeVideos: IYouTubeVideoFieldsFragment[];
}

export default function VideosContent({ youtubeVideos }: VideosContentProps) {
  const video = youtubeVideos.find((youtubeVideo) => youtubeVideo.position === 1) ?? youtubeVideos[0];

  if (!video) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4 font-aeonik">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <FormattedMessage defaultMessage="Nenhum vídeo foi encontrado." id="msMgUQ" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full items-start justify-center">
      <div className="relative aspect-video w-full max-w-[831px]">
        <iframe
          title={video.title}
          className="absolute left-0 top-0 h-full w-full rounded-lg"
          allowFullScreen={true}
          src={getEmbedUrl(video)}
        />
      </div>
    </div>
  );
}

function getEmbedUrl(video: IYouTubeVideoFieldsFragment) {
  try {
    const url = new URL(video.url);
    if (url.searchParams.has("t")) {
      const startTime = url.searchParams.get("t");
      return `https://www.youtube-nocookie.com/embed/${video.id}?rel=0&start=${startTime}`;
    }
  } catch {} // eslint-disable-line
  return `https://www.youtube-nocookie.com/embed/${video.id}?rel=0`;
}
